module.exports = __webpack_public_path__ + "static/img/race2020-1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/race2020-1.jpg
// module id = QKNI
// module chunks = 0